import { AppRoute, WithRequired } from "./types";

//:- All Application Pages
import HubLogin from "../pages/login";
import HubForgotPassword from  '../pages/forgotpassword';
import NewEnrollment from "../pages/newEnrollment";
import HubUploadPEF from "../pages/uploadPEF";
import HubResetPassword from "../pages/resetpassword";
import Dashboard from "../pages/dashboard";
import HubAddCase from "../pages/addCase";
import HubCreateUser from "../pages/createUser";
import HubCaseDetail from "src/pages/caseDetail";
import AddProvider from "../pages/addProvider";
import AddUser from "../pages/addUser";
import NewRepVisit from "../pages/newRepVisit";
import BaaAgreement from "../pages/baa";
import manufacturer from "src/pages/manufacturer";
import HubCaseClone from "src/pages/cloneCase";
import Territories from "src/pages/territories";
import TreatmentListing from "src/pages/treatmentListing";
import OrderListing from "src/pages/orderListing";
import Precert from "src/pages/precert";
import HubUpdateUser from "src/pages/updateuser";
import Regions from "src/pages/regions";
// import District from "src/pages/tbms";
import PracticeStats from "src/pages/practiceStats";
import DoctorStats from "src/pages/doctorStats";
import RetreatmentRequests from "src/pages/retreatmentRequests";
import DoctorListingPage from "../pages/signatureManagement";
import HubVideoReviewer from "src/pages/videoViewer";
import Document from "src/pages/document";
import RXPADocument from "src/pages/rxpaDocument";
import TBMs from "src/pages/tbms";
import KAMLeads from "src/pages/kamLeads";
import PatientNavigatorLeads from "src/pages/patientNavigatorLeads";
import DBM from "src/pages/dbm";

const defaultRoute: WithRequired<WithRequired<Partial<AppRoute>, 'isIndex'>, 'removeHeaderandFooter'> = {
  isIndex: false,
  removeHeaderandFooter: false,
};

export const PublicRoutes: AppRoute[] = [
  { ...defaultRoute, route: '/users/sign_in', component: HubLogin, isIndex: true },
  { ...defaultRoute, route: '/users/forgotpassword', component: HubForgotPassword },
  { ...defaultRoute, route: '/users/password/new', component: HubForgotPassword },
  { ...defaultRoute, route: '/enrollments/new', component: NewEnrollment },
  { ...defaultRoute, route: '/faxes_ins/new', component: HubUploadPEF },
  { ...defaultRoute, route: '/videos/:video_name', component: HubVideoReviewer },
  { ...defaultRoute, route: '/set_new_password', component: HubResetPassword },
];

export const AuthenticatedRoutes: AppRoute[] = [
  { ...defaultRoute, route: '/cases', component: Dashboard, isIndex: true },
  { ...defaultRoute, route: '/retreatments', component: RetreatmentRequests },
  { ...defaultRoute, route: '/cases/new', component: HubAddCase },
  { ...defaultRoute, route: '/cases/detail/:caseId', component: HubCaseDetail },
  { ...defaultRoute, route: '/cases/:caseId/documents/new', component: Document },
  { ...defaultRoute, route: '/cases/:caseId/document/new', component: RXPADocument },
  { ...defaultRoute, route: '/users/createuser', component: HubCreateUser },
  { ...defaultRoute, route: '/users/updateuser', component: HubUpdateUser },
  { ...defaultRoute, route: '/doctors/new', component: AddProvider },
  { ...defaultRoute, route: '/users/new', component: AddUser },
  { ...defaultRoute, route: '/rep_visits/new', component: NewRepVisit },
  { ...defaultRoute, route: '/treatments', component: TreatmentListing },
  { ...defaultRoute, route: '/orders', component: OrderListing },
  { ...defaultRoute, route: '/pages/signaturemanagement', component: DoctorListingPage },
  { ...defaultRoute, route: '/pages/baa', component: BaaAgreement },
  { ...defaultRoute, route: '/cases/:caseId/clone', component: HubCaseClone },
  { ...defaultRoute, route: '/cases/:caseId/precerts/:precertsId/edit', component: Precert },
  { ...defaultRoute, route: '/cases/:caseId/insurances/:insuranceId/precerts/:precertsId/edit', component: Precert },
  { ...defaultRoute, route: '/videos/:video_name', component: HubVideoReviewer },
];

const getCommonRoutes = (options?: {
  statisticsIndex?: boolean;
}): AppRoute[] => [
  {
    ...defaultRoute,
    route: '/statistics/:id',
    component: Territories,
    ...(options?.statisticsIndex ? { isIndex: true } : {}),
  },
  { ...defaultRoute, route: '/practice_stats/:pracId', component: PracticeStats },
  { ...defaultRoute, route: '/doctor_stats/:docId', component: DoctorStats },
  { ...defaultRoute, route: '/users/createuser', component: HubCreateUser },
  { ...defaultRoute, route: '/users/updateuser', component: HubUpdateUser },
  { ...defaultRoute, route: '/pages/signaturemanagement', component: DoctorListingPage },
  { ...defaultRoute, route: '/pages/baa', component: BaaAgreement },
  { ...defaultRoute, route: '/videos/enrollment_tutorial', component: HubVideoReviewer },
];

export const ManufacturerRoutes: AppRoute[] = [
  { ...defaultRoute, route: '/statistics', component: manufacturer, isIndex: true },
  { ...defaultRoute, route: '/regions', component: Regions },
  { ...defaultRoute, route: '/tbms/:id', component: TBMs },
  { ...defaultRoute, route: '/kamleads/:id', component: KAMLeads },
  { ...defaultRoute, route: '/patientNavigatorLeads/:id', component: PatientNavigatorLeads },
   { ...defaultRoute, route: '/dbm/:id', component: DBM },
  ...getCommonRoutes(),
];
export const TBMRoutes: AppRoute[] = [
  { ...defaultRoute, route: '/tbms/:id', component: TBMs, isIndex: true },
  ...getCommonRoutes(),
];

export const PNLeadsRoutes: AppRoute[] = [
  { ...defaultRoute, route: '/patientNavigatorLeads/:id', component: PatientNavigatorLeads, isIndex: true },
  ...getCommonRoutes(),
];

export const KAMLeadsRoutes: AppRoute[] = [
  { ...defaultRoute, route: '/kamleads/:id', component: KAMLeads, isIndex: true },
  ...getCommonRoutes(),
];

export const RepRoutes: AppRoute[] = [
  ...getCommonRoutes({ statisticsIndex: true }),
];

export const DBMRoutes: AppRoute[] = [
    { ...defaultRoute, route: '/dbm/:id', component: DBM, isIndex: true },
  ...getCommonRoutes({ statisticsIndex: true }),
];

